<template>
  <error :headline="headline">
    <template slot="image">
      <img class="football" alt="football" src="../../assets/images/19a-lrn-spt-cat-2-icon-def.svg"/>
    </template>
    <template slot="message">
      <p>Your account has no active subscriptions. Please <router-link :to="{path: '/contact-us'}">contact us</router-link> to renew or if you feel you reached this page by mistake.</p>
    </template>
  </error>
</template>

<script>
  import Error from '@/component/Error';

  export default {
    name: 'InvalidSubscription',

    components: {
      Error,
    },

    data: function() {
      return {
        interval: null,
        headline: 'No Active Subscriptions!',
      }
    },

    mounted: function () {
      this.interval = setTimeout(() => {
        this.$router.push({name: 'home'});
      }, 20000)
    },

    beforeRouteLeave (to, from, next) {
      clearInterval(this.interval);
      next();
    }
  };
</script>
